import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import LabelText from '../LabelText';
import { dispatchOptionField } from '../../../Util/Util';

const Gender = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const {form_component, formFields} = props;

	const fv = useSelector(state => state.fv);
	const pageData = useSelector(state => state.pageData);
	const controller = pageData.controller;
	const userData = useSelector(state => state.userData);
	const optionFields = useSelector(state => state.optionFields);
	const curStep = useSelector(state => state.curStep);
	const jumpHistory = useSelector(state => state.jumpHistory) || [];
	
	// 使用本地狀態來管理選中的值
	const [selectedValue, setSelectedValue] = useState(userData?.gender || '');

	// 同步 userData 的變化
	useEffect(() => {
		if (userData?.gender) {
			setSelectedValue(userData.gender);
		}
	}, [userData?.gender]);

	const registerField = () => {
		// For Shopcarts controller, only use global validator
		// For other controllers, use Redux store validator
		const validator = controller === 'Shopcarts' ? window.globalFormValidator : fv;
		
		if (validator && form_component.required) {
			const fieldName = 'gender';
			
			try {
				// Check if field already exists and remove it first
				if (validator.elements && validator.elements[fieldName]) {
					validator.removeField(fieldName);
				}
				
				validator.addField(fieldName, {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						}
					},
					// Explicitly specify the element selector
					selector: `input[name="${fieldName}"]`
				});
			} catch (error) {
				console.error('Error registering field:', fieldName, error);
			}
		}
	};

	useEffect(() => { // to be updated after render
		registerField();
	}, [fv, controller, form_component.required, t]);

	// Listen for FormValidation reinitialization
	useEffect(() => {
		const handleReinitialization = (event) => {
			registerField();
		};

		document.addEventListener('formValidationReinitialized', handleReinitialization);
		
		return () => {
			document.removeEventListener('formValidationReinitialized', handleReinitialization);
		};
	}, [fv, controller, form_component.required, t]);

	const onChange = (e) => {
		const {value} = e.target;
		setSelectedValue(value);
		
		const selectedOption = form_component.options?.find(opt => opt.value === value);
		
		if (formFields && formFields.form_components) {
			dispatchOptionField(
				dispatch, 
				form_component, 
				value, 
				optionFields, 
				curStep, 
				formFields.form_components, 
				selectedOption,
				jumpHistory
			);
		}
	};

	return (
		<div className={`flex-grow-1 form-group text ${form_component.required ? 'required' : ''}`}>
			<LabelText
				form_component={form_component}
			/>
		 	<div className={`label_box ${form_component.option_display === '1R1D' ? 'label-full' : 'label-50'}`}>
		 		{(() => {
		 			const components = [];
		 			
		 			form_component.options?.map((option, index) => {
		 				components.push(
		 					<React.Fragment key={`option-${index}`}>
		 					<input
		 						className="form-check-input"
		 						type="radio"
		 						name="gender"
		 						id={`gender-${option.value}`}
		 						value={option.value}
		 						checked={selectedValue === option.value}
		 						onChange={onChange}
		 					/>
		 					<label
		 						className="form-check-label"
		 						htmlFor={`gender-${option.value}`}
		 					>
								<div className="d-flex gap-3 opt">
									<div className="x-radio"></div>
									<div className="ans">
				 					    <p className="mb-0">{option.label}</p>
				 					    <div className="pic w-100">
				 					    
				 					    </div>
			 						</div>
			 					</div>
			 				</label>
		 					</React.Fragment>
		 				);
		 			});

		 			return components;
		 		})()}
		  </div>
		</div>
	);
}

export default Gender;